import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CertificateView } from "@/features/courses/components/certificates/certificate-view";

function CertificatePage() {
  const params = useParams({ from: "/u/$u/certificates/$certId" });
  return <CertificateView certId={params().certId} />;
}

export const certificateRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/certificates/$certId",
  component: CertificatePage,
});
